// @ts-check
import _ from 'lodash';

import TextPanel from './TextPanel';
import ActiveAlarmListPanel from './ActiveAlarmListPanel';
import ChartPanel from './ChartPanel';
// import SignalInfoPanel from './SignalInfoPanel';
import TelemetryCardsPanel from './TelemetryCardsPanel/TelemetryCardsPanel';
import DialPanelV2 from './dial/DialPanelV2';
import RealTimeDialPanelList from './dial/RealTimeDialPanelList';
import LastValueDialPanelList from './dial/LastValueDialPanelList';
import DialPanel from './dialOld/DialPanel';
import MapPanel from './MapPanel';
import PropertyPanel from './PropertyPanel';
import AssetListPanel from './AssetListPanel';

/**
 * @typedef {object} PanelInfo
 * @property {string} label - Label to show in the panel type dropdown
 * @property {JSX.Element} icon - Icon to show in the panel type dropdown
 * @property {string} help - Help page to show when clicking the help button
 */

/**
 * @typedef {object} PanelProperties
 */

/**
 * @typedef {object} PanelComponentExtraData
 * @property {PanelInfo} info - Label to show in the panel type dropdown
 * @property {PanelProperties[]|((panel: Record<string, object>) => PanelProperties[])} [properties] - Properties to show in the property panel
 * @property {array} [models] - Models to show in the property panel
 */

/**
 * @typedef {React.ComponentType<any>} MemoComponent
 * @property {React.FunctionComponent<any>} ()
 * @property {PanelInfo} info
 * @property {PanelProperties|((panel: Record<string, object>) => PanelProperties)} [properties] - Properties to show in the property panel
 * @property {array} [models] - Models to show in the property panel
 */

/**
 * @typedef {React.FunctionComponent<any> & PanelComponentExtraData} NonMemoPanelComponent
 */

const panels = {
  text: TextPanel,
  activeAlarmList: ActiveAlarmListPanel,
  chart: ChartPanel,
  dial: DialPanel,
  dialv2: DialPanelV2,
  realtimeDialList: RealTimeDialPanelList,
  lastValueDialList: LastValueDialPanelList,
  // signalInfo: SignalInfoPanel,
  telemetryCards: TelemetryCardsPanel,
  map: MapPanel,
  property: PropertyPanel,
  assetList: AssetListPanel
};

// Pure object infos, removes the memo's 'type' instance from the component so we do not need to use
// '<obj>.type ?? <obj>' in the code:
// Use this to get normal static data from components
// Do not use this to instantiate UX components
/**
 * @type {Record<string, NonMemoPanelComponent>}
 */
export const panelObjects = _.reduce(panels, (result, value, key) => {
  // TODO: Remove @ts-ignore when type is correct. It does not seem to pickup MemoExoticComponent correct
  // @ts-ignore
  return { ...result, [key]: value.type ?? value };
}, {});

export default panels;
